<template>
  <div class="evaluation">
    <div class="title">
      <b>我的数据魔方</b>
    </div>
    <div class="main">
      <div class="rank_row">
        <div class="team_box">
          <div class="box_title">
            <span class="tab">{{
              isEnd ? "团队期末排行" : "团队实时排行"
            }}</span>
            <span class="more" @click="handleShowList('team')"
              >详情 <i class="el-icon-arrow-right"></i
            ></span>
          </div>
          <div class="list_box">
            <div class="score-box teach-score" v-if="classInfo.douyin">
              <p class="score-title">教学成绩</p>
              <div class="score">
                <p>
                  {{ Number((teamRank.score || 0).toFixed(1)) }}
                </p>
              </div>
            </div>
            <div class="rank">
              <p class="r">
                第 <span>{{ teamRank.top }}</span> 名
              </p>
              <p class="s" v-if="!classInfo.douyin">
                {{ Number((teamRank.score || 0).toFixed(1)) }}
              </p>
            </div>
            <div class="score-box practice-score" v-if="classInfo.douyin">
              <p class="score-title">实战成绩</p>
              <div class="score">
                <p>
                  {{ Number((teamRank.douyinScore || 0).toFixed(1)) }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="radar">
          <div class="box_title">评价雷达图</div>
          <div class="radar_box">
            <ve-radar
              width="280px"
              height="220px"
              :data="chartData"
              :settings="radarSet"
              :extend="chartExtend"
            ></ve-radar>
          </div>
        </div>
        <div class="personal_box">
          <div class="box_title">
            <span class="tab">{{
              isEnd ? "个人期末排行" : "个人实时排行"
            }}</span>
            <span class="more" @click="handleShowList('user')"
              >详情 <i class="el-icon-arrow-right"></i
            ></span>
          </div>
          <div class="list_box">
            <div class="score-box teach-score" v-if="classInfo.douyin">
              <p class="score-title">教学成绩</p>
              <div class="score">
                <p>
                  {{ Number((myRank.score || 0).toFixed(1)) }}
                </p>
              </div>
            </div>
            <div class="rank">
              <p class="r">
                第 <span>{{ myRank.top }}</span> 名
              </p>
              <p class="s" v-if="!classInfo.douyin">
                {{ Number((myRank.score || 0).toFixed(1)) }}
              </p>
            </div>
            <div class="score-box practice-score" v-if="classInfo.douyin">
              <p class="score-title">实战成绩</p>
              <div class="score">
                <p>
                  {{ Number((myRank.douyinScore || 0).toFixed(1)) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="score_row">
        <div class="score_box" v-for="item in scoreList" :key="item.id">
          <p class="score_title">{{ item.title }}</p>
          <div class="circle_box" @click="goDetail(item.path, item.id)">
            <el-progress
              type="circle"
              :percentage="item.score"
              color="#1de0fe"
              stroke-linecap="square"
              :width="105"
              :stroke-width="10"
              :format="format"
            ></el-progress>
            <!-- <span class="text">分</span> -->
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="titleText + '章节成绩列表'"
      :visible.sync="showList"
      center
      width="60%"
    >
      <el-table
        class="score-list"
        :data="chapterScoreList"
        row-key="chapterId"
        default-expand-all
        height="calc(50vh)"
      >
        <el-table-column prop="chapterName" label="章节" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.chapterName }}</span>
            <el-tag
              v-if="scope.row.sz"
              style="margin-left: 10px"
              effect="dark"
              size="mini"
              >实训</el-tag
            >
            <el-tag
              v-if="scope.row.mock"
              style="margin-left: 10px"
              effect="dark"
              type="warning"
              size="mini"
              >仿真实训</el-tag
            >
            <el-tag
              v-if="scope.row.teamGrade"
              style="margin-left: 10px"
              effect="dark"
              type="success"
              size="mini"
              >评价</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="zsScore"
          label="知识考核"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="tdScore"
          label="态度考核"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="jnScore"
          label="技能考核"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="syScore"
          label="素养考核"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="totalScore"
          label="总分"
          width="80"
          align="center"
        >
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  classAvg,
  teamRanking,
  personalRanking,
  personalFinalRanking,
  myScore,
} from "@/api/evaluation";
import { chapterList } from "@/api/chapter";
import { handleTree } from "@/utils/index";

export default {
  props: {
    classInfo: Object,
  },
  data() {
    return {
      chartData: {
        columns: ["", "tdAvgScore", "zsAvgScore", "jnAvgScore", "syAvgScore"],
        rows: [{ tdAvgScore: 0, syAvgScore: 0, jnAvgScore: 0, zsAvgScore: 0 }],
      },
      chartExtend: {
        radar: {
          shape: "polygon",
          indicator: [
            { name: "态度", max: 100, color: "#51a9e1" },
            { name: "知识", max: 100, color: "#51a9e1" },
            { name: "技能", max: 100, color: "#51a9e1" },
            { name: "素养", max: 100, color: "#51a9e1" },
          ],
        },
      },
      radarSet: {
        labelMap: {
          tdAvgScore: "态度",
          syAvgScore: "素养",
          jnAvgScore: "技能",
          zsAvgScore: "知识",
        },
        itemStyle: {
          color: "rgba(255, 228, 52, 0.5)",
          borderWidth: 5,
        },
        lineStyle: {
          color: "rgba(255, 228, 52, 0.5)",
        },
        areaStyle: {
          color: "rgba(255, 228, 52, 0.5)",
        },
      },
      myRank: {},
      teamRank: {},
      scoreList: [
        {
          id: 1,
          title: "知识考核平均分",
          score: 0,
          path: "/classCourse/evaluation/knowledge",
        },
        {
          id: 2,
          title: "态度考核平均分",
          score: 0,
          path: "/classCourse/evaluation/attitude",
        },
        {
          id: 3,
          title: "技能考核平均分",
          score: 0,
          path: "/classCourse/evaluation/skill",
        },
        {
          id: 4,
          title: "素养考核平均分",
          score: 0,
          path: "/classCourse/evaluation/attainment",
        },
        { id: 5, title: "期末考试分数", score: 0 },
        { id: 6, title: "教师考核分数", score: 0 },
      ],
      haveComplete: false,
      showList: false,
      titleText: "",
      chapterScoreList: [],
    };
  },
  created() {
    this.getChapterList();
    this.getClassScore();
    this.getTeamRanking();
    this.getPersonalRanking();
  },
  computed: {
    isEnd() {
      return this.classInfo.complete;
    },
  },
  // watch: {
  //   isEnd() {
  //     this.getPersonalRanking();
  //   },
  // },
  methods: {
    // 章节列表
    getChapterList() {
      chapterList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.haveComplete = res.data.find((item) => {
            return item.complete;
          });
        } else {
          console.log(res.msg);
        }
      });
    },
    // 班级平均分
    getClassScore() {
      this.$loading.show();
      classAvg(this.$route.query.id).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.classScore = res.data;
          this.scoreList[0].score = Number(
            (res.data.zsAvgScore || 0).toFixed(1)
          );
          this.scoreList[1].score = Number(
            (res.data.tdAvgScore || 0).toFixed(1)
          );
          this.scoreList[2].score = Number(
            (res.data.jnAvgScore || 0).toFixed(1)
          );
          this.scoreList[3].score = Number(
            (res.data.syAvgScore || 0).toFixed(1)
          );
          this.scoreList[4].score = Number(
            (res.data.endAvgScore || 0).toFixed(1)
          );
          this.scoreList[5].score = Number(
            (res.data.endTeacherAvgScore || 0).toFixed(1)
          );

          this.chartData.rows[0].tdAvgScore = Number(
            (res.data.tdAvgScore || 0).toFixed(1)
          );
          this.chartData.rows[0].syAvgScore = Number(
            (res.data.syAvgScore || 0).toFixed(1)
          );
          this.chartData.rows[0].jnAvgScore = Number(
            (res.data.jnAvgScore || 0).toFixed(1)
          );
          this.chartData.rows[0].zsAvgScore = Number(
            (res.data.zsAvgScore || 0).toFixed(1)
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 团队排行榜
    getTeamRanking() {
      teamRanking(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          this.teamRank = res.data || {};
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 个人排行榜
    getPersonalRanking() {
      // if (this.isEnd) {
      //   personalFinalRanking(this.$route.query.id).then((res) => {
      //     if (res.code == 0) {
      //       this.myRank = res.data || {};
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   });
      // } else {
      personalRanking(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          this.myRank = res.data || {};
        } else {
          this.$message.error(res.msg);
        }
      });
      // }
    },
    format(percentage) {
      return percentage + "";
    },
    goDetail(path, id) {
      if (id < 5 && !this.haveComplete) {
        this.$message.warning("尚未有章节生成了成绩");
        return;
      }
      this.$router.push({ path, query: this.$route.query });
    },
    handleShowList(type) {
      this.showList = true;
      this.titleText = type == "team" ? "团队" : "个人";
      this.$loading.show();
      myScore({
        classId: this.$route.query.id,
        type,
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.chapterScoreList = handleTree(res.data, "chapterId");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.evaluation {
  height: 640px;
  background-image: url("../../../assets/images/evaluation_bg.png");
  background-size: cover;
  .title {
    padding-top: 40px;
    height: 105px;
    text-align: center;
    background-image: url("../../../assets/images/title_bg.png");
    background-size: cover;
    b {
      letter-spacing: 5px;
      font-size: 30px;
      color: transparent;
      background-image: linear-gradient(180deg, #fff, #fff, #1de0fe, #1de0fe);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .main {
    margin: 15px 2px 0;
    .rank_row {
      .team_box,
      .personal_box {
        display: inline-block;
        width: 440px;
        vertical-align: top;
        .list_box {
          position: relative;
          padding-top: 10px;
          height: 240px;
          font-size: 16px;
          box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
          overflow-y: auto;
          .score-box {
            position: absolute;
            top: 60px;
            &.teach-score {
              left: 36px;
            }
            &.practice-score {
              right: 36px;
            }
            .score-title {
              position: relative;
              color: rgba(29, 224, 254, 0.8);
              &::after {
                content: "";
                position: absolute;
                left: 50%;
                bottom: -5px;
                transform: translateX(-50%);
                width: 70%;
                height: 1px;
                background-color: rgba(29, 224, 254, 0.6);
              }
            }
            .score {
              display: inline-block;
              margin-top: 40px;
              width: 88px;
              height: 58px;
              background-image: url("../../../assets/images/score_base.png");
              p {
                margin-top: -18px;
                font-weight: bold;
                font-size: 24px;
                color: #fe68af;
                span {
                  margin-left: 5px;
                  font-size: 14px;
                  font-weight: normal;
                }
              }
            }
          }
          .rank {
            display: inline-block;
            width: 136px;
            height: 205px;
            font-weight: bold;
            font-size: 14px;
            color: #ffcc00;
            background-image: url("../../../assets/images/rank_base.png");
            .r {
              margin-top: 20px;
              span {
                font-size: 50px;
                font-weight: bold;
              }
            }
            .s {
              margin-top: 50px;
              font-weight: bold;
              font-size: 24px;
              color: #fe68af;
              span {
                margin-left: 5px;
                font-size: 14px;
                font-weight: normal;
              }
            }
          }

          .tips {
            position: absolute;
            right: 120px;
            top: 70px;
            color: #1de0fe;
          }
        }
      }
      .radar {
        display: inline-block;
        margin: 0 16px;
        width: 280px;
        vertical-align: top;
        .radar_box {
          padding: 10px 0;
          box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
        }
      }
      .box_title {
        padding: 0 10px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        color: #1de0fe;
        background-color: rgba(49, 70, 125, 0.1);
        // border: solid 1px rgba(4, 20, 40, 0.1);
        box-shadow: #6be4f7 0px 0px 5px inset;
        overflow: hidden;
        .tab {
          margin-left: 45px;
        }
        .more {
          float: right;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }

    .score_row {
      margin-top: 15px;
      .score_box {
        display: inline-block;
        width: 190px;
        &:not(:last-child) {
          margin-right: 10px;
        }
        .score_title {
          padding: 0 10px;
          height: 48px;
          line-height: 48px;
          font-size: 16px;
          color: #1de0fe;
          background-color: rgba(49, 70, 125, 0.1);
          // border: solid 1px rgba(4, 20, 40, 0.1);
          box-shadow: #1de0fe 0px 0px 5px inset;
        }
        .circle_box {
          position: relative;
          padding-top: 28px;
          height: 160px;
          box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
          cursor: pointer;
          ::v-deep .el-progress__text {
            // padding-right: 10px;
            color: #1de0fe;
            font-size: 30px !important;
          }
          .text {
            position: absolute;
            top: 47%;
            right: 35%;
            color: #1de0fe;
          }
        }
      }
    }
  }
  ::v-deep .score-list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>